import axios from 'axios'
import {UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const BASE_URL = process.env.REACT_APP_APIIP

export const LOGIN_URL = `${API_URL}/login`
export const LOST_PASSWORD_URL = `${BASE_URL}/users/lostpassword`
export const UPDATE_PASSWORD_URL = `${BASE_URL}/users/newpassword`
export const EMAIL_LOGIN_URL = `${BASE_URL}/users/emaillogin`

// Server should return AuthModel
export function login(username: string, password: string) {
  return axios.post(BASE_URL + '/users/authenticate', {username, password})
}

export function totpauthenticate(totp: string, AToken: string) {
  return axios.post(BASE_URL + '/users/totpauthenticate', {totp, AToken})
}

export function lostPassword(email: string, lastname: string, ssn4: string, pagetype: string) {
  return axios.post<{result: boolean}>(LOST_PASSWORD_URL, {
    email,
    lastname,
    ssn4,
    pagetype
  })
}

export function emailLogin(username: string, dateofbirth: string) {
  return axios.post<{result: boolean}>(EMAIL_LOGIN_URL, {
    username,
    dateofbirth
  })
}

export function updatePassword(userName: string, newPass: string, registerguid: string, lostpasswordguid: string, resetguid: string) {
  return axios.put<{result: boolean}>(UPDATE_PASSWORD_URL, {
    userName,
    registerguid,
    newPass,
    lostpasswordguid,
    resetguid
  })
}
